/** @format */

import type { QueryClient } from "@tanstack/react-query";
import { WebSocketProvider } from "./api/WebSocketProvider";
import { OfflineBanner } from "./components/OfflineBanner";
import PWAInstallBanner from "./components/PWAInstallBanner";
import SignUpBanner from "./components/SignUpBanner";
import { usePWAInstallPrompt } from "./hooks/usePWAInstallPrompt";
import { TanStackRouterProvider, TanStackRouterProviderSSR } from "./router";
import NotificationToast from "./utils/NotificationToast";
import UpdateToast from "./utils/UpdateToast";

interface LiveWrapperProps {
  ssrContext?: {
    routeMatch?: unknown;
  };
  queryClient?: QueryClient;
  isSSR?: boolean;
}

const LiveWrapper = ({
  ssrContext: _ssrContext,
  queryClient,
  isSSR = false,
}: LiveWrapperProps = {}) => {
  // PWA install prompt listeners (visit counting, beforeinstallprompt, appinstalled)
  usePWAInstallPrompt();

  return (
    <WebSocketProvider>
      <OfflineBanner />
      {isSSR && queryClient ? (
        <TanStackRouterProviderSSR queryClient={queryClient} />
      ) : (
        <TanStackRouterProvider />
      )}
      <NotificationToast />
      <UpdateToast />
      <PWAInstallBanner />
      <SignUpBanner />
    </WebSocketProvider>
  );
};

export default LiveWrapper;
